package com.eladfinish.bible.contest.screens.randomVerse.model

enum class RandomVersePart {
    HALF,
    FULL,
}
